const pushServerPublicKey = "BLzDUgfBqLpZhDFNPXO103yJmqkQIut2qp4xxLJKvvmct6v0QQDZ1WshJE6SXINqk9XBuBSPSkG8VOyN9_JhSdY";

/**
 * checks if Push notification and service workers are supported by your browser
 */
function isPushNotificationSupported() {
    return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
}

/**
 * asks user consent to receive push notifications and returns the response of the user, one of granted, default, denied
 */
async function askUserPermission() {
    return isPushNotificationSupported() ?
        await Notification.requestPermission() : null;
}
/**
 * shows a notification
 */
function sendNotification(title, message) {
    // const img = "/images/jason-leung-HM6TMmevbZQ-unsplash.jpg";
    // const message = "BS Portaal boodskap";
    // const title = "Jy het 'n boodskap op die boerdery stelsel portaal";
    const options = {
        body: message || "Jy het 'n boodskap op die boerdery stelsel portaal",
        // icon: "/images/jason-leung-HM6TMmevbZQ-unsplash.jpg",
        vibrate: [200, 100, 200],
        // tag: "new-product",
        // image: img,
        // badge: "https://spyna.it/icons/android-icon-192x192.png",
        // actions: [{ action: "Detail", title: "View", icon: "https://via.placeholder.com/128/ff0000" }]
    };
    navigator.serviceWorker.ready.then(function(serviceWorker) {
        console.log("[Notification received]");
        serviceWorker.showNotification(title || "BS Portaal boodskap", options);
    });
}

/**
 *
 */
function registerServiceWorker() {
    return navigator.serviceWorker.register("/sw.js");
}

/**
 *
 * using the registered service worker creates a push notification subscription and returns it
 *
 */
async function createNotificationSubscription() {
    //wait for service worker installation to be ready
    const serviceWorker = await navigator.serviceWorker.ready;
    // subscribe and return the subscription
    return await serviceWorker.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: pushServerPublicKey
    });
}

/**
 * returns the subscription if present or nothing
 */
function getUserSubscription() {
    //wait for service worker installation to be ready, and then
    return navigator.serviceWorker.ready
        .then(function(serviceWorker) {
            return serviceWorker.pushManager.getSubscription();
        })
        .then(function(pushSubscription) {
            return pushSubscription;
        });
}

export {
    isPushNotificationSupported,
    askUserPermission,
    registerServiceWorker,
    sendNotification,
    createNotificationSubscription,
    getUserSubscription
};